import React, { useState, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
// import { jobs } from "../../common/data";
import { Modal } from "../../components/Modal";
// import { Button } from "../../components/Button";
import { useTranslation } from "react-i18next";

import "./styles.less";

const FormModal = (props) => {
  const { visible, setVisible, currentJob } = props;
  const { t } = useTranslation();

  return (
    <Modal {...{ visible, setVisible }}>
      <div className="apply-modal">
        <i onClick={() => setVisible(false)} className="icon authing-icon authing-guanbi" />
        <div className="apply-title">{t("common.form.apply-title")}</div>
        <div className="apply-position-label">{t("common.form.apply-position")}</div>
        <div className="apply-position-value">{currentJob.title}</div>
        <div className="apply-method">{t("common.form.apply-method")}</div>
        <div className="apply-info">
          {t("common.form.mail-address")}：
          <a href={`mailto:mayanjun@authing.cn?subject=姓名-${currentJob.title}`}>mayanjun@authing.cn</a>
        </div>
        <div className="apply-info">{t("common.form.mail-title")}</div>
        <div className="apply-info">{t("common.form.mail-content")}</div>
      </div>
    </Modal>
  );
};

export const JoinusDetail = (props) => {
  const nav = useNavigate();
  const { id } = useParams();
  const { t } = useTranslation();
  const jobLink = (id) => {
    nav(`/joinus/${id}`);
  };
  const linkPath = (path) => {
    nav(path);
  };
  const [visible, setVisible] = useState(false);
  const list = [
    { id: 1, title: `${t("joinus.jobs.job-one.title")}` },
    { id: 2, title: `${t("joinus.jobs.job-two.title")}` },
    { id: 3, title: `${t("joinus.jobs.job-three.title")}` },
    { id: 4, title: `${t("joinus.jobs.job-four.title")}` },
    { id: 5, title: `${t("joinus.jobs.job-five.title")}` },
    { id: 6, title: `${t("joinus.jobs.job-six.title")}` },
    { id: 7, title: `${t("joinus.jobs.job-seven.title")}` },
    { id: 8, title: `${t("joinus.jobs.job-eight.title")}` },
    { id: 9, title: `${t("joinus.jobs.job-nine.title")}` },
    { id: 10, title: `${t("joinus.jobs.job-ten.title")}` },
    { id: 11, title: `${t("joinus.jobs.job-11.title")}` },
    { id: 12, title: `${t("joinus.jobs.job-12.title")}` },
    { id: 13, title: `${t("joinus.jobs.job-13.title")}` },
    { id: 14, title: `${t("joinus.jobs.job-14.title")}` },
    { id: 15, title: `${t("joinus.jobs.job-15.title")}` },
    { id: 16, title: `${t("joinus.jobs.job-16.title")}` },
    { id: 17, title: `${t("joinus.jobs.job-17.title")}` },
    { id: 18, title: `${t("joinus.jobs.job-18.title")}` },
    // { id: 19, title: `${t("joinus.jobs.job-19.title")}` },
    { id: 20, title: `${t("joinus.jobs.job-20.title")}` },
    { id: 21, title: `${t("joinus.jobs.job-21.title")}` },
    { id: 22, title: `${t("joinus.jobs.job-22.title")}` },
  ];
  const jobs = [
    {
      // type: "developer".工程师 2.产品 3.商务
      type: "developer",
      id: 1,
      title: `${t("joinus.jobs.job-one.title")}`,
      time: "2020-12-10",
      desc: [
        `${t("joinus.jobs.job-one.description.item0")}`,
        `${t("joinus.jobs.job-one.description.item1")}`,
        `${t("joinus.jobs.job-one.description.item2")}`,
        `${t("joinus.jobs.job-one.description.item3")}`,
        `${t("joinus.jobs.job-one.description.item4")}`,
        `${t("joinus.jobs.job-one.description.item5")}`,
        `${t("joinus.jobs.job-one.description.item6")}`,
        `${t("joinus.jobs.job-one.description.item7")}`,
      ],
      skills: [
        `${t("joinus.jobs.job-one.skills.item0")}`,
        `${t("joinus.jobs.job-one.skills.item1")}`,
        `${t("joinus.jobs.job-one.skills.item2")}`,
        `${t("joinus.jobs.job-one.skills.item3")}`,
        `${t("joinus.jobs.job-one.skills.item4")}`,
        `${t("joinus.jobs.job-one.skills.item5")}`,
        `${t("joinus.jobs.job-one.skills.item6")}`,
        `${t("joinus.jobs.job-one.skills.item7")}`,
      ],
    },
    {
      type: "developer",
      id: 2,
      title: `${t("joinus.jobs.job-two.title")}`,
      time: "2020-12-10",
      desc: [
        `${t("joinus.jobs.job-two.description.item0")}`,
        `${t("joinus.jobs.job-two.description.item1")}`,
        `${t("joinus.jobs.job-two.description.item2")}`,
      ],
      skills: [
        `${t("joinus.jobs.job-two.skills.item0")}`,
        `${t("joinus.jobs.job-two.skills.item1")}`,
        `${t("joinus.jobs.job-two.skills.item2")}`,
        `${t("joinus.jobs.job-two.skills.item3")}`,
        `${t("joinus.jobs.job-two.skills.item4")}`,
        `${t("joinus.jobs.job-two.skills.item5")}`,
        `${t("joinus.jobs.job-two.skills.item6")}`,
      ],
    },
    {
      type: "developer",
      id: 3,
      title: `${t("joinus.jobs.job-three.title")}`,
      time: "2020-12-10",
      desc: [`${t("joinus.jobs.job-three.description.item0")}`, `${t("joinus.jobs.job-three.description.item1")}`],
      skills: [
        `${t("joinus.jobs.job-three.skills.item0")}`,
        `${t("joinus.jobs.job-three.skills.item1")}`,
        `${t("joinus.jobs.job-three.skills.item2")}`,
        `${t("joinus.jobs.job-three.skills.item3")}`,
        `${t("joinus.jobs.job-three.skills.item4")}`,
        `${t("joinus.jobs.job-three.skills.item5")}`,
        `${t("joinus.jobs.job-three.skills.item6")}`,
        `${t("joinus.jobs.job-three.skills.item7")}`,
      ],
    },
    {
      type: "developer",
      id: 21,
      title: `${t("joinus.jobs.job-21.title")}`,
      time: "2021-03-31",
      desc: [
        `${t("joinus.jobs.job-21.description.item0")}`,
        `${t("joinus.jobs.job-21.description.item1")}`,
        `${t("joinus.jobs.job-21.description.item2")}`,
        `${t("joinus.jobs.job-21.description.item3")}`,
      ],
      skills: [
        `${t("joinus.jobs.job-21.skills.item0")}`,
        `${t("joinus.jobs.job-21.skills.item1")}`,
        `${t("joinus.jobs.job-21.skills.item2")}`,
        `${t("joinus.jobs.job-21.skills.item3")}`,
      ],
    },
    {
      type: "developer",
      id: 4,
      title: `${t("joinus.jobs.job-four.title")}`,
      time: "2020-12-10",
      desc: [`${t("joinus.jobs.job-four.description.item0")}`],
      skills: [
        `${t("joinus.jobs.job-four.skills.item0")}`,
        `${t("joinus.jobs.job-four.skills.item1")}`,
        `${t("joinus.jobs.job-four.skills.item2")}`,
        `${t("joinus.jobs.job-four.skills.item3")}`,
      ],
    },
    {
      type: "developer",
      id: 5,
      title: `${t("joinus.jobs.job-five.title")}`,
      time: "2020-08-21",
      desc: [
        `${t("joinus.jobs.job-five.description.item0")}`,
        `${t("joinus.jobs.job-five.description.item1")}`,
        `${t("joinus.jobs.job-five.description.item2")}`,
        `${t("joinus.jobs.job-five.description.item3")}`,
        `${t("joinus.jobs.job-five.description.item4")}`,
        `${t("joinus.jobs.job-five.description.item5")}`,
        `${t("joinus.jobs.job-five.description.item6")}`,
        `${t("joinus.jobs.job-five.description.item7")}`,
      ],
      skills: [
        `${t("joinus.jobs.job-five.skills.item0")}`,
        `${t("joinus.jobs.job-five.skills.item1")}`,
        `${t("joinus.jobs.job-five.skills.item2")}`,
        `${t("joinus.jobs.job-five.skills.item3")}`,
        `${t("joinus.jobs.job-five.skills.item4")}`,
        `${t("joinus.jobs.job-five.skills.item5")}`,
        `${t("joinus.jobs.job-five.skills.item6")}`,
        `${t("joinus.jobs.job-five.skills.item7")}`,
      ],
    },
    {
      type: "developer",
      id: 6,
      title: `${t("joinus.jobs.job-six.title")}`,
      time: "2020-11-4",
      desc: [
        `${t("joinus.jobs.job-six.description.item0")}`,
        `${t("joinus.jobs.job-six.description.item1")}`,
        `${t("joinus.jobs.job-six.description.item3")}`,
        `${t("joinus.jobs.job-six.description.item4")}`,
        `${t("joinus.jobs.job-six.description.item5")}`,
        `${t("joinus.jobs.job-six.description.item6")}`,
      ],
      skills: [
        `${t("joinus.jobs.job-six.skills.item0")}`,
        `${t("joinus.jobs.job-six.skills.item1")}`,
        `${t("joinus.jobs.job-six.skills.item2")}`,
        `${t("joinus.jobs.job-six.skills.item3")}`,
        `${t("joinus.jobs.job-six.skills.item4")}`,
        `${t("joinus.jobs.job-six.skills.item5")}`,
      ],
    },
    {
      type: "developer",
      id: 7,
      title: `${t("joinus.jobs.job-seven.title")}`,
      time: "2020-11-4",
      desc: [
        `${t("joinus.jobs.job-seven.description.item0")}`,
        `${t("joinus.jobs.job-seven.description.item1")}`,
        `${t("joinus.jobs.job-seven.description.item3")}`,
      ],
      skills: [
        `${t("joinus.jobs.job-seven.skills.item0")}`,
        `${t("joinus.jobs.job-seven.skills.item1")}`,
        `${t("joinus.jobs.job-seven.skills.item2")}`,
        `${t("joinus.jobs.job-seven.skills.item3")}`,
        `${t("joinus.jobs.job-seven.skills.item4")}`,
        `${t("joinus.jobs.job-seven.skills.item5")}`,
      ],
    },
    {
      type: "developer",
      id: 8,
      title: `${t("joinus.jobs.job-eight.title")}`,
      time: "2020-12-10",
      desc: [
        `${t("joinus.jobs.job-eight.description.item0")}`,
        `${t("joinus.jobs.job-eight.description.item1")}`,
        `${t("joinus.jobs.job-eight.description.item2")}`,
      ],
      skills: [
        `${t("joinus.jobs.job-eight.skills.item0")}`,
        `${t("joinus.jobs.job-eight.skills.item1")}`,
        `${t("joinus.jobs.job-eight.skills.item2")}`,
        `${t("joinus.jobs.job-eight.skills.item3")}`,
        `${t("joinus.jobs.job-eight.skills.item4")}`,
        `${t("joinus.jobs.job-eight.skills.item5")}`,
      ],
    },
    {
      type: "business",
      id: 9,
      title: `${t("joinus.jobs.job-nine.title")}`,
      time: "2020-12-10",
      desc: [
        `${t("joinus.jobs.job-nine.description.item0")}`,
        `${t("joinus.jobs.job-nine.description.item1")}`,
        `${t("joinus.jobs.job-nine.description.item2")}`,
        `${t("joinus.jobs.job-nine.description.item3")}`,
        `${t("joinus.jobs.job-nine.description.item4")}`,
      ],
      skills: [
        `${t("joinus.jobs.job-nine.skills.item0")}`,
        `${t("joinus.jobs.job-nine.skills.item1")}`,
        `${t("joinus.jobs.job-nine.skills.item2")}`,
        `${t("joinus.jobs.job-nine.skills.item3")}`,
        `${t("joinus.jobs.job-nine.skills.item4")}`,
        `${t("joinus.jobs.job-nine.skills.item5")}`,
        `${t("joinus.jobs.job-nine.skills.item6")}`,
        `${t("joinus.jobs.job-nine.skills.item7")}`,
      ],
    },
    {
      type: "developer",
      id: 10,
      title: `${t("joinus.jobs.job-ten.title")}`,
      time: "2020-12-10",
      desc: [
        `${t("joinus.jobs.job-ten.description.item0")}`,
        `${t("joinus.jobs.job-ten.description.item1")}`,
        `${t("joinus.jobs.job-ten.description.item2")}`,
        `${t("joinus.jobs.job-ten.description.item3")}`,
      ],
      skills: [
        `${t("joinus.jobs.job-ten.skills.item0")}`,
        `${t("joinus.jobs.job-ten.skills.item1")}`,
        `${t("joinus.jobs.job-ten.skills.item2")}`,
        `${t("joinus.jobs.job-ten.skills.item3")}`,
        `${t("joinus.jobs.job-ten.skills.item4")}`,
        `${t("joinus.jobs.job-ten.skills.item5")}`,
        `${t("joinus.jobs.job-ten.skills.item6")}`,
        `${t("joinus.jobs.job-ten.skills.item7")}`,
      ],
    },
    {
      type: "developer",
      id: 11,
      title: `${t("joinus.jobs.job-11.title")}`,
      time: "2020-12-10",
      desc: [
        `${t("joinus.jobs.job-11.description.item0")}`,
        `${t("joinus.jobs.job-11.description.item1")}`,
        `${t("joinus.jobs.job-11.description.item2")}`,
        `${t("joinus.jobs.job-11.description.item3")}`,
      ],
      skills: [
        `${t("joinus.jobs.job-11.skills.item0")}`,
        `${t("joinus.jobs.job-11.skills.item1")}`,
        `${t("joinus.jobs.job-11.skills.item2")}`,
        `${t("joinus.jobs.job-11.skills.item3")}`,
        `${t("joinus.jobs.job-11.skills.item4")}`,
        `${t("joinus.jobs.job-11.skills.item5")}`,
        `${t("joinus.jobs.job-11.skills.item6")}`,
        `${t("joinus.jobs.job-11.skills.item7")}`,
        `${t("joinus.jobs.job-11.skills.item8")}`,
        `${t("joinus.jobs.job-11.skills.item9")}`,
        `${t("joinus.jobs.job-11.skills.item10")}`,
        `${t("joinus.jobs.job-11.skills.item11")}`,
      ],
    },
    {
      type: "developer",
      id: 12,
      title: `${t("joinus.jobs.job-12.title")}`,
      time: "2020-12-10",
      desc: [
        `${t("joinus.jobs.job-12.description.item0")}`,
        `${t("joinus.jobs.job-12.description.item1")}`,
        `${t("joinus.jobs.job-12.description.item2")}`,
        `${t("joinus.jobs.job-12.description.item3")}`,
        `${t("joinus.jobs.job-12.description.item4")}`,
        `${t("joinus.jobs.job-12.description.item5")}`,
        `${t("joinus.jobs.job-12.description.item6")}`,
      ],
      skills: [
        `${t("joinus.jobs.job-12.skills.item0")}`,
        `${t("joinus.jobs.job-12.skills.item1")}`,
        `${t("joinus.jobs.job-12.skills.item2")}`,
        `${t("joinus.jobs.job-12.skills.item3")}`,
        `${t("joinus.jobs.job-12.skills.item4")}`,
        `${t("joinus.jobs.job-12.skills.item5")}`,
        `${t("joinus.jobs.job-12.skills.item6")}`,
        `${t("joinus.jobs.job-12.skills.item7")}`,
        `${t("joinus.jobs.job-12.skills.item8")}`,
        `${t("joinus.jobs.job-12.skills.item9")}`,
        `${t("joinus.jobs.job-12.skills.item10")}`,
        `${t("joinus.jobs.job-12.skills.item11")}`,
      ],
    },
    {
      type: "developer",
      id: 13,
      title: `${t("joinus.jobs.job-13.title")}`,
      time: "2020-12-10",
      desc: [
        `${t("joinus.jobs.job-13.description.item0")}`,
        `${t("joinus.jobs.job-13.description.item1")}`,
        `${t("joinus.jobs.job-13.description.item2")}`,
        `${t("joinus.jobs.job-13.description.item3")}`,
        `${t("joinus.jobs.job-13.description.item4")}`,
      ],
      skills: [
        `${t("joinus.jobs.job-13.skills.item0")}`,
        `${t("joinus.jobs.job-13.skills.item1")}`,
        `${t("joinus.jobs.job-13.skills.item2")}`,
        `${t("joinus.jobs.job-13.skills.item3")}`,
        `${t("joinus.jobs.job-13.skills.item4")}`,
      ],
    },
    {
      type: "developer",
      id: 14,
      title: `${t("joinus.jobs.job-14.title")}`,
      time: "2020-12-10",
      desc: [
        `${t("joinus.jobs.job-14.description.item0")}`,
        `${t("joinus.jobs.job-14.description.item1")}`,
        `${t("joinus.jobs.job-14.description.item2")}`,
      ],
      skills: [
        `${t("joinus.jobs.job-14.skills.item0")}`,
        `${t("joinus.jobs.job-14.skills.item1")}`,
        `${t("joinus.jobs.job-14.skills.item2")}`,
        `${t("joinus.jobs.job-14.skills.item3")}`,
      ],
    },
    {
      type: "developer",
      id: 15,
      title: `${t("joinus.jobs.job-15.title")}`,
      time: "2020-12-10",
      desc: [
        `${t("joinus.jobs.job-15.description.item0")}`,
        `${t("joinus.jobs.job-15.description.item1")}`,
        `${t("joinus.jobs.job-15.description.item2")}`,
        `${t("joinus.jobs.job-15.description.item3")}`,
        `${t("joinus.jobs.job-15.description.item4")}`,
      ],
      skills: [
        `${t("joinus.jobs.job-15.skills.item0")}`,
        `${t("joinus.jobs.job-15.skills.item1")}`,
        `${t("joinus.jobs.job-15.skills.item2")}`,
        `${t("joinus.jobs.job-15.skills.item3")}`,
      ],
    },
    {
      type: "developer",
      id: 16,
      title: `${t("joinus.jobs.job-16.title")}`,
      time: "2020-12-10",
      desc: [
        `${t("joinus.jobs.job-16.description.item0")}`,
        `${t("joinus.jobs.job-16.description.item1")}`,
        `${t("joinus.jobs.job-16.description.item2")}`,
        `${t("joinus.jobs.job-16.description.item3")}`,
        `${t("joinus.jobs.job-16.description.item4")}`,
        `${t("joinus.jobs.job-16.description.item5")}`,
        `${t("joinus.jobs.job-16.description.item6")}`,
        `${t("joinus.jobs.job-16.description.item7")}`,
      ],
      skills: [
        `${t("joinus.jobs.job-16.skills.item0")}`,
        `${t("joinus.jobs.job-16.skills.item1")}`,
        `${t("joinus.jobs.job-16.skills.item2")}`,
        `${t("joinus.jobs.job-16.skills.item3")}`,
        `${t("joinus.jobs.job-16.skills.item4")}`,
      ],
    },
    {
      type: "developer",
      id: 17,
      title: `${t("joinus.jobs.job-17.title")}`,
      time: "2020-12-10",
      desc: [
        `${t("joinus.jobs.job-17.description.item0")}`,
        `${t("joinus.jobs.job-17.description.item1")}`,
        `${t("joinus.jobs.job-17.description.item2")}`,
        `${t("joinus.jobs.job-17.description.item3")}`,
        `${t("joinus.jobs.job-17.description.item4")}`,
        `${t("joinus.jobs.job-17.description.item5")}`,
      ],
      skills: [
        `${t("joinus.jobs.job-17.skills.item0")}`,
        `${t("joinus.jobs.job-17.skills.item1")}`,
        `${t("joinus.jobs.job-17.skills.item2")}`,
        `${t("joinus.jobs.job-17.skills.item3")}`,
        `${t("joinus.jobs.job-17.skills.item4")}`,
      ],
    },
    {
      type: "developer",
      id: 18,
      title: `${t("joinus.jobs.job-18.title")}`,
      time: "2020-12-10",
      desc: [
        `${t("joinus.jobs.job-18.description.item0")}`,
        `${t("joinus.jobs.job-18.description.item1")}`,
        `${t("joinus.jobs.job-18.description.item2")}`,
      ],
      skills: [
        `${t("joinus.jobs.job-18.skills.item0")}`,
        `${t("joinus.jobs.job-18.skills.item1")}`,
        `${t("joinus.jobs.job-18.skills.item2")}`,
        `${t("joinus.jobs.job-18.skills.item3")}`,
        `${t("joinus.jobs.job-18.skills.item4")}`,
      ],
    },
    // {
    //   type: "other",
    //   id: 19,
    //   title: `${t("joinus.jobs.job-19.title")}`,
    //   time: "2020-12-10",
    //   desc: [
    //     `${t("joinus.jobs.job-19.description.item0")}`,
    //     `${t("joinus.jobs.job-19.description.item1")}`,
    //     `${t("joinus.jobs.job-19.description.item2")}`,
    //     `${t("joinus.jobs.job-19.description.item3")}`,
    //     `${t("joinus.jobs.job-19.description.item4")}`,
    //   ],
    //   skills: [
    //     `${t("joinus.jobs.job-19.skills.item0")}`,
    //     `${t("joinus.jobs.job-19.skills.item1")}`,
    //     `${t("joinus.jobs.job-19.skills.item2")}`,
    //     `${t("joinus.jobs.job-19.skills.item3")}`,
    //   ],
    // },
    {
      type: "other",
      id: 20,
      title: `${t("joinus.jobs.job-20.title")}`,
      time: "2020-12-30",
      desc: [
        `${t("joinus.jobs.job-20.description.item0")}`,
        `${t("joinus.jobs.job-20.description.item1")}`,
        `${t("joinus.jobs.job-20.description.item2")}`,
        `${t("joinus.jobs.job-20.description.item3")}`,
      ],
      skills: [
        `${t("joinus.jobs.job-20.skills.item0")}`,
        `${t("joinus.jobs.job-20.skills.item1")}`,
        `${t("joinus.jobs.job-20.skills.item2")}`,
        `${t("joinus.jobs.job-20.skills.item3")}`,
      ],
    },
    
    {
      type: "other",
      id: 22,
      title: `${t("joinus.jobs.job-22.title")}`,
      time: "2021-03-31",
      desc: [
        `${t("joinus.jobs.job-22.description.item0")}`,
        `${t("joinus.jobs.job-22.description.item1")}`,
        `${t("joinus.jobs.job-22.description.item2")}`,
        `${t("joinus.jobs.job-22.description.item3")}`,
      ],
      skills: [
        `${t("joinus.jobs.job-22.skills.item0")}`,
        `${t("joinus.jobs.job-22.skills.item1")}`,
        `${t("joinus.jobs.job-22.skills.item2")}`,
        `${t("joinus.jobs.job-22.skills.item3")}`,
      ],
    },
  ];
  const currentJob = useMemo(() => {
    let _currentJob;
    jobs.forEach((item) => {
      if (item.id === Number(id)) {
        _currentJob = item;
      }
    });
    return _currentJob;
  }, [id, jobs]);

  return (
    <div className="joinus-content">
      <section className="joinus-detail">
        <div className="inner">
          <div className="nav-bar">
            <span
              onClick={() => {
                linkPath("/about");
              }}
            >
              {t("joinus.job-detail.navbar.nav0")}
              <span style={{ paddingRight: 8, paddingLeft: 8 }}>/</span>
            </span>
            <span
              onClick={() => {
                linkPath("/joinus");
              }}
            >
              {t("joinus.job-detail.navbar.nav1")} <span style={{ paddingRight: 8, paddingLeft: 8 }}>/</span>
            </span>
            <span style={{ color: "#666666", cursor: "default" }}>{currentJob?.title}</span>
          </div>
          <div className="job-content">
            <div className="job-text">
              <div className="job-title">{currentJob?.title}</div>
              <div className="job-time">
                {t("joinus.job-detail.publishtimer")} : {currentJob?.time}
              </div>

              <div className="job-require">
                <div className="job-label">{t("joinus.job-detail.label-description")}</div>
                {(currentJob?.desc || []).map((item) => {
                  return <div className="item">{item}</div>;
                })}
              </div>
              <div className="job-description">
                <div className="job-label">{t("joinus.job-detail.label-skills")}</div>

                {(currentJob?.skills || []).map((item) => {
                  return <div className="item">{item}</div>;
                })}
              </div>
            </div>

            <div className="job-apply">
              <div
                className="apply-button"
                onClick={() => {
                  setVisible(true);
                }}
              >
                {t("joinus.job-detail.button-apply")}
              </div>
              <div className="apply-other">
                <div className="title">
                  <span>{t("joinus.job-detail.label-newjob")}</span>
                  {/* <span className="more">更多</span> */}
                </div>
                {list.map((item) => {
                  return (
                    <div
                      className="item"
                      onClick={() => {
                        jobLink(item.id);
                      }}
                    >
                      {item.title}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="share-job">
        <div className="inner">
          <div className="item">
            <span>分享这个职位：</span>
          </div>
          <div className="item">
            <span>或使用链接分享：</span>
            <input placeholder="我们的顾问将尽快致电你" type="text" />
            <span className="link-btn">复制链接</span>
          </div>
        </div>
      </section> */}
      <FormModal {...{ visible, setVisible, currentJob }} />
    </div>
  );
};
